export const Numbers = {

	methods: {
		formatMoney(value) {
			if (typeof value === "string") {
				value = Number.parseFloat(value);
			}
			if (typeof value !== "number") {
				return "-";
			}
			return this.formatCurrency(value);
		},

		formatCurrency(n) {
			if (n || n === 0) {
				const rounded = Math.round(n * 100) / 100;
				return (rounded).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$& ").replace(/\./g, ",");
			} else {
				return "";
			}
		},

		formatWithoutFixed(value) {
			if (typeof value === "string") {
				value = Number.parseFloat(value);
			}
			if (typeof value !== "number") {
				return "-";
			}
			if (value || value === 0) {
				return (value).toString().replace(/\d(?=(\d{3})+\.)/g, "$& ").replace(/\./g, ",");
			} else {
				return "";
			}
		},

		formatPercentage(val, whole) {
			if (isNaN(val)) {
				return "0,00";
			}

			const res = (100 * val / whole).toFixed(2);

			if (isNaN(res)) {
				return "0,00";
			}

			return res.replace(/\./g, ",");
		},

		formatMoneyWithCode(value, currencyCode) {
			const formattedMoney = this.formatMoney(value);
			return formattedMoney === '-' ? '' : `${formattedMoney} ${currencyCode  || 'PLN'}`;
		},

		parseToFloat (value) {
			if (typeof value === "string") {
				return parseFloat(value.replace(/,/g, "."));
			} else return value;
		},

		// Rounds n to 2 decimal places using HALF_UP, matching Java's
		// BigDecimal.setScale(2, RoundingMode.HALF_UP).
		// Strategy: multiply by 10000 and round to the nearest integer — this gives
		// an exact 4th-decimal representation so the true 3rd decimal digit can be
		// extracted without double-rounding. Multiplying by only 1000 would round
		// the 3rd digit itself (e.g. X.XX45 * 1000 = XXX4.5 → Math.round → XXX5,
		// making the algorithm report thirdDigit=5 and round up incorrectly).
		// Example that was broken: 0.55 * 0.59 = 0.3245 → old: 0.33, correct: 0.32.
		roundHalfUp(n) {
			const sign = n < 0 ? -1 : 1;
			const abs = Math.abs(n);
			const tenthousandths = Math.round(abs * 10000); // nearest 0.0001 unit
			const thirdDigit = Math.floor(tenthousandths / 10) % 10;
			const cents = Math.floor(tenthousandths / 100);
			return sign * (thirdDigit >= 5 ? cents + 1 : cents) / 100;
		}
	},

};
